import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo, useCallback, useState } from "react";
import { getDashboardUrl } from "../../core/auth";
import { useAuth } from "../../core/auth-provider";
import { FeedbackModal } from "./feedback-modal";

export const ExitOnboardingButton = memo(function ExitOnboardingButton({
  className,
  renderAsArbiterButton = false,
  skipPrompt = false,
  text = "Exit to Dashboard",
  textClassName,
}: {
  className?: string;
  renderAsArbiterButton?: boolean;
  skipPrompt?: boolean;
  text?: string;
  textClassName?: string;
}) {
  const auth = useAuth();
  const href = getDashboardUrl(auth?.token);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = useCallback(() => {
    if (skipPrompt) {
      window.location.href = href;
      return;
    }
    setIsModalOpen(true);
  }, [href, skipPrompt]);

  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleConfirm = useCallback(() => {
    window.location.href = href;
  }, [href]);

  return (
    <>
      {renderAsArbiterButton ? (
        <RedoButton
          hierarchy="secondary"
          onClick={handleButtonClick}
          size="sm"
          text={text}
        />
      ) : (
        // design-allow: Product onboarding retains its existing styled control outside this landing-page change.
        <button className={className} onClick={handleButtonClick} type="button">
          <span className={textClassName}>{text}</span>
        </button>
      )}
      {!skipPrompt && (
        <FeedbackModal
          isOpen={isModalOpen}
          onClose={handleClose}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
});
